/**
 * Rendered by the "Kukutis: pair it with" section when a product has no complementary products.
 * Switches the surrounding product-recommendations component to another intent (related);
 * the component's own attribute observer then loads and renders that list.
 */
class KkRecommendationsFallback extends HTMLElement {
  connectedCallback() {
    const recommendations = this.closest('product-recommendations');
    const intent = this.dataset.intent;
    if (!(recommendations instanceof HTMLElement) || !intent || recommendations.dataset.intent === intent) return;

    recommendations.dataset.intent = intent;
    recommendations.dataset.recommendationsPerformed = 'false';
  }
}

if (!customElements.get('kk-recommendations-fallback')) {
  customElements.define('kk-recommendations-fallback', KkRecommendationsFallback);
}
